import {SET_TOASTER_MESSAGE} from "@/store/this_app/mutations";

export default {
    methods: {
        searchArrayOfObjectsForAdjacentValue(myArray, nameKey, value) {
            for (let i = 0; i < myArray.length; i++) {
                if (myArray[i][nameKey] === value) {
                    return myArray[i].name;
                }
            }
        },

        closeViewItem() {
            this.toggleViewDialog();
        },

        closeEditItem() {
            this.toggleEditDialog();
            setTimeout(() => {
                this.fetchItem(this.id);
                this.resetEditItemToDefault();
                this.editedId = -1
            }, 300)
        },

        editDialog(id) {
            this.loadTableItemToEdit(id);
            this.toggleEditDialog();
        },

        viewItem(item) {
            this.editedId = item[this.idName];
            this.loadTableItemToView(this.editedId);
            this.toggleViewDialog();
        },

        editItem(item) {
            this.editedId = item[this.idName];
            this.loadTableItemToEdit(this.editedId);
            this.toggleEditDialog();
        },

        deleteItem(item) {
            const params = {};
            params.personId = this.personId;
            params[this.idName] = item[this.idName];
            confirm('Are you sure you want to delete this item?') && this.deleteTableItem(params);
        },

        close() {
            this.dialog = false;
            setTimeout(() => {
                this.resetEditItemToDefault();
                this.editedId = -1
            }, 300)
        },

        closeNewItem() {
            this.toggleAddDialog();
            this.resetNewItemToDefaultAndResetValidation();
            this.editedId = -1
        },

        save() {
            if (this.editedId > -1) {
                this.updateTableItemRecord();
            } else {
                this.saveNewTableItemRecord(this.personId);
                this.$forceUpdate();
            }
            this.close()
        },


        async saveEditItemAndCloseDialog() {
            // debugger;
            let areValid = this.validateAll();

            const validationResult = await areValid;

            if (validationResult === true) {
                this.updateTableItemRecord();
                this.closeEditItem()
            } else {
                this.$store.commit(SET_TOASTER_MESSAGE, {state: true, value: 'Form has errors'});

            }

        },

        async saveNewItemAndCloseDialog() {

            // debugger;
            let areValid = this.validateAll();

            const validationResult = await areValid;

            if (validationResult === true) {
                this.saveNewTableItemRecord();
                this.resetNewItemToDefaultAndResetValidation();
                this.closeNewItem();
            } else {
                this.$store.commit(SET_TOASTER_MESSAGE, {state: true, value: 'Form has errors'});
            }
        },

        async validateAll() {
            this.$v.$touch();

            let formState = false;

            if (this.$v.$anyDirty === false) {
                formState = 'clean';
            } else {
                if (this.$v.$anyError === true) {
                    formState = 'error';
                } else {
                    formState = 'complete';
                }
            }

            let areValid = false;

            if (formState == 'complete') {
                areValid = true;
            }

            return areValid;
        },

        fetchAllTableItems() {
            // const action = `FETCH_PERSON_${this.table}_LIST`;
            this.fetchTableList();
            // this.$store.dispatch(this.fetchTableList(), this.personId);
        },

        updateNewValue(key, value) {
            let data = {};
            data.key = key;
            data.value = value;

            this.updateTableItemToAdd(data);
        },

        updateEditedValue(key, value) {
            let data = {};
            data.key = key;
            data.value = value;
            this.updateTableItemToEdit(data);
        },

        resetNewItemToDefaultAndResetValidation() {
            let personId;
            if (this.person) {
                personId = this.person.personId;
            } else {
                personId = this.personId;
            }

            this.resetNewItemToDefault(personId);
            this.$v.$reset();
            // this.updateNewValue('personId', this.personId);
        },

        updateValue(key, value) {
            this.updateEditedValue(key, value);
        },
    }


};
